<template>
  <div>
    <nut-dialog title="请输入个人账号（ps：'mj'开头）" :visible="dialogShow" @ok-btn-click="goNext"
                @cancel-btn-click="handleClose" @close="handleClose">
      <nut-textinput
        v-model="username"
        placeholder="请输入账号"
        :clearBtn="true"
        :disabled="false"
      />
    </nut-dialog>
    <div style="padding: 10px" v-if="showTask==true">
      <div style="margin-bottom: 10px">
        <nut-cell
          :show-icon="true"
          title="请选择作业"
          :desc="option"
          @click.native="openSwitch('isVisible')">
        </nut-cell>
        <nut-picker
          :is-visible="isVisible"
          :list-data="listData"
          :default-value-data="defaultValueData"
          @close="closeSwitch('isVisible')"
          @confirm="confirm"
        ></nut-picker>
      </div>
      <div style="margin-bottom: 10px">
        <h5 style="padding: 5px">上传素描图片</h5>
        <el-upload class="upload-demo" :on-preview="handlePictureCardPreview" :action="uploadUrl"
                    :on-exceed="exceed" show-file-list
                   :file-list="imgList" :limit="2"
                   :on-success="(res, file, fileList)=>{return handleInfoSuccess(res, file, fileList, index)}"
                   :on-remove="(file, fileList)=>{return handleInfoRemove(file, fileList, index)}"
                   list-type="picture-card">
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <div style="margin-bottom: 10px">
        <nut-textbox v-model="student_des" place-text="相关理解："></nut-textbox>
      </div>
      <div style="text-align: center">
        <nut-button
          type="light"
          shape="circle"
          @click="handleClose"
        >
          关闭
        </nut-button>
        <nut-button
          shape="circle"
          @click="submitTask"
        >
          提交
        </nut-button>
      </div>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
  </div>
</template>

<script>
    import wx from 'weixin-js-sdk'
    export default {
        name: "taskUpload",
        data() {
            return {
                progressNum:0,
                previewImg: [
                ],
                dialogShow: true,
                student_des: '',
                username: '',
                class_id: 0,
                taskId: 0,
                showTask: false,
                isVisible: false,
                option: '请选择',
                imgList: [],
                imgList2: [],
                listData: [],
                defaultValueData: null,
                token: '',
                uploadUrl: this.GLOBAL.BASE_URL + '/api/common/upload_file',
                dialogVisible:false,
                dialogImageUrl:''
            };
        },
        methods: {
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            exceed(files, fileList) {
                this.$toast.warn("最多只能上传2张图片！")
            },
            submitTask() {
                if (!this.task_id)
                {
                    this.$toast.warn('请选择课程!')
                    return false
                }if (this.imgList.length<1)
                {
                    this.$toast.warn('请至少上传一张图片！')
                    return false
                }
                var params = {
                    task_id: this.task_id,
                    student_answer: this.imgList,
                    student_des: this.student_des
                }
                this.$http.insert_student_record(params)
                    .then(res => {
                        if (res.code != 0) {
                            this.$toast.success(res.message);
                        } else {
                            this.$toast.fail(res.message);
                        }

                    })
            },
            openSwitch(param) {
                this[`${param}`] = true;
            },

            closeSwitch(param) {
                this[`${param}`] = false;
            },

            confirm(chooseData) {
                this.option = `${chooseData[0].value}`;
                this.task_id = `${chooseData[0].label}`;
            },
            goNext() {
                if (this.username) {
                    this.$http.checkUser({username: this.username}).then(res => {
                        if (res.code != 0) {
                            this.$cookies.set('token', res.data.token);
                            this.token = res.data.token;
                            this.class_id=res.data.class_id
                            this.$http.taskclass({cate: 3, page_size: 100000,class_id:this.class_id}).then(res => {
                                const list=[]
                                if (res.code !=0) {
                                    res.data.task.forEach(i=>{
                                        list.push({value:i.title,label:i.id})
                                    })
                                    this.listData = [list];
                                    this.dialogShow = false;
                                    this.showTask = true;
                                } else {
                                    this.$toast.fail(res.message);
                                }
                            })
                        } else {
                            this.$toast.fail(res.message);
                        }

                    }).catch(error => {
                        this.$toast.fail(error.message)
                    });

                } else {
                    this.$toast.warn('请输入账号');
                }

            },
            handleClose () {
                var ua = window.navigator.userAgent.toLowerCase();
                // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
                if (ua.indexOf('micromessenger') > -1) {
                    wx.closeWindow()
                } else {
                    window.close();
                }
            },
            // 产品详情 图片上传成功
            handleInfoSuccess(res, file, fileList, index) {
                this.$toast.success('上传成功')
                this.imgList.push(res.data)
                var imgObject = {
                    "url": this.GLOBAL.BASE_URL + res.data,
                    'name': file.name
                }
                this.imgList2.push(imgObject)
            },
            // 产品详情 图片删除成功
            handleInfoRemove(file, fileList, index) {
                var arr = this.imgList2;
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].name == file.name) {
                        this.imgList.splice(i, 1)
                        this.imgList2.splice(i, 1)
                    }
                }

            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/taskUpload.vue